import pulsar from '../elements/pulsar.js';
pulsar.register();
